export const WARRANTY_PROVIDER_EVENTS = {
    detailPageImpression: {
        eventName: "custom_event",
        eventCategory: "Cars24_detail_page",
        eventAction: "impression",
        eventLabel: "{categoryKey}_impression"
    },
    checkoutPageImpression: {
        eventName: "custom_event",
        eventCategory: "Cars24_checkout_page",
        eventAction: "impression",
        eventLabel: "{categoryKey}_impression"
    },
    checkoutPageBrochureViewed: {
        eventName: "custom_event",
        eventCategory: "Cars24_checkout_page",
        eventAction: "brochure_viewed",
        eventLabel: "{categoryKey}_brochure_viewed"
    },
    postBcVasImpression: {
        eventName: "custom_event",
        eventCategory: "Post_BC_VAS",
        eventAction: "impression",
        eventLabel: "{categoryKey}_impression"
    },
    postBcVasBrochureViewed: {
        eventName: "custom_event",
        eventCategory: "Post_BC_VAS",
        eventAction: "brochure_viewed",
        eventLabel: "{categoryKey}_brochure_viewed"
    },
    postBcVasImpressionUpselling: {
        eventName: "custom_event",
        eventCategory: "Post_BC_VAS",
        eventAction: "impression",
        eventLabel: "{categoryKey}_impression_upselling"
    },
    postBcVasBrochureViewedUpselling: {
        eventName: "custom_event",
        eventCategory: "Post_BC_VAS",
        eventAction: "brochure_viewed",
        eventLabel: "{categoryKey}_brochure_viewed_upselling"
    }
};
